import React from 'react'
import Slider from "react-slick";
import {FiCheck, FiStar, FiUsers, FiMapPin, 
    FiDollarSign, FiBriefcase, FiCalendar, FiPlay, FiChevronDown,
      FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import Navbar from '../../../@shared/navigations/default';
import { Follow } from './follow';
import { ProjectApply } from './apply';
import { OpenPositions } from './open_positions';
import { ProjectStatus } from './status';
import { ProjectOwner } from './owner';

const exampleProject = {
    title:'Lorem ipsum dolor sit amet consectetur adipisicing',
    desc:'Enim dolorem optio facere, deserunt illum maxime est pariatur in? Blanditiis explicabo dolore ipsa? Non aliquam debitis nemo aut voluptates nihil distinctio! ',
    tags:[12,3,213,215,326,323,3],
    date:'2021-01-15',
    user:{
        name:'Test',
        first:'Tester',
        last:'Test',
        date:'2021-01-15'
    }
}

const ProjectPage = () => {
    require('slick-carousel/slick/slick.css')
    require('slick-carousel/slick/slick-theme.css')

    const [project] = React.useState(exampleProject);
  
    const settings = {
        arrows:true,
        dots:true,
        infinite: true,
        speed: 500,
        autoplay: false,
        variableWidth: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 2,
        swipe:true,
        prevArrow:<button type="button" className="slick-next"><FiChevronLeft /></button>,
        nextArrow:<button type="button" className="slick-next"><FiChevronRight /></button>,
     };
    let readMore = React.useRef()
    let about = React.useRef()
    function showReadMore() {
        about.current.style = 'max-height:100%'
        readMore.current.style = 'display:none'
    } 
    
    return   (
      <>
      <Navbar /> 
        { project?._id  && (<ProjectStatus 
            projectId={project._id}
            userId={project?.user._id}
            exists={{}} 
        />)}

        <div className="project_show__page">
        <div className="project__carousel">
            <Slider
                className="slider"
                {...settings}
            >
                {Array.from(Array(5)).map((image,i)=>(
                    <div  key={'slider-image-'+i} ><img alt="" src={`/assets/images/projects/${i}.jpg`}/></div>
                ))}
            </Slider>
        </div>  
            <br />
            <div className="project__content">
                <div className="project__detail">
                   <h2>{project?.title} #{project?.code}</h2>
                    {
                        project?.desc && (
                            <div className="project_show__frame about" ref={about}> 
                                <h3>Description</h3>
                            { project?.desc && project?.desc.split('\n').map((item, key) => <p key={key}>{item}<br/></p>) }
                                <p className="read-more" ref={readMore} >
                                    <div className="btn" onClick={e=>{
                                        e.preventDefault();
                                        showReadMore()
                                    }}>Read More</div>
                                </p>
                            </div>
                        )
                    }
                    {
                        project?.tags?.length>0 && (
                            <div className="project_show__frame"> 
                            <h3>Tags</h3>
                                <div className="row">
                                    <ul className="features">
                                        <li><div className="feature_icon"><FiCheck /></div> Internet</li>
                                        <li><div className="feature_icon"><FiCheck /></div> Window Covering</li>
                                        <li><div className="feature_icon"><FiCheck /></div> Gym</li>
                                        <li><div className="feature_icon"><FiCheck /></div> Swimming pool</li>
                                    </ul>
                                </div>
                            </div>
                        ) 
                    }
                   <div className="project_show__frame"> 
                      <h3>Skills</h3>
                       <div className="row">
                            <ul className="skills">
                                <li><FiStar className="skill-star" /> <b className="skill-star">5 </b> Kubernetes</li>
                                <li><FiStar className="skill-star" /> <b className="skill-star">2 </b> Sass</li>
                                <li><FiStar className="skill-star" /> <b className="skill-star">5 </b> Git</li>
                                <li>React</li>
                                <li>Vuejs</li>
                                <li>Amazon Web Services</li>
                            </ul>
                        </div>
                    </div>
                  <div className="project_show__frame"> 
                        <div className="project_show_team">
                            <div className="team_head">
                                <FiUsers />
                                <h4 className="team_title">Team</h4>
                            </div>
                            <ul>
                                {
                                [3,5,7].map(item=>{
                                        return (
                                            <li key={'project-person'+item}>
                                                <a href='#'>
                                                    <a className="team_person online">
                                                        <img alt="" src="/assets/images/faces/1.png" />
                                                    </a>
                                                    <div>
                                                        <h3>Tom Smith </h3>
                                                        <div className="team_stars">
                                                            <FiStar />
                                                            <FiStar />
                                                            <FiStar />
                                                            {/*
                                                            <ReactStars count={5} value={2} onChange={ratingChanged} size={27} half={false} color1={'#ffd62c'} color2={'#ebc62d'}  />
                                                            */}
                                                            <p className="team_desc">Minimum of 3 votes required</p>
                                                        </div>
                                                    </div>
                                                </a>
                                                <div><FiCheck/></div>
                                            </li>
                                        )
                                    })
                                }
                               </ul>
                        </div>
                   </div>
                   
                 {project?._id && (
                     <OpenPositions 
                     requirements={project?.requirements}
                     projectId={project?._id}
                  />
                 )}
                   
                 <ProjectApply />
     
                        <div className="list_frame">
                        <div className="heading">
                            <h3>Gallery</h3>
                            <div className="list_icon">
                                <FiChevronDown />
                            </div>
                        </div>
                        <div className="project_show__gallery" >
                            {Array.from(Array(5)).map((image,i)=>(
                                <img alt="" key={'gallery-'+i} src={`/assets/images/projects/${i}.jpg`} />
                            ))}
                            
                        </div>
                    </div>
                  
                                
                        <div className="project_show__team list_frame">
                            <div className="heading">
                                <h4>Team</h4>
                                <div className="list_icon">
                                    <FiChevronDown />
                                </div>
                            </div>
                        </div>
                        <div className="project_show__tags list_frame">
                            <div className="heading">
                                <h4>Tags</h4>
                                <div className="list_icon">
                                    <FiChevronDown />
                                </div>
                            </div>
                        </div> 
                        
                </div>  
                
                <div className="project__rightbar">
                    
                    <Follow />
                
                   <ProjectOwner />

                   <div className="projectshow_smilar_property">
                        <h3>Similar Propery</h3>
                        <ul>
                          {
                              [1,2,3].map((item,i)=>(
                                <li key={'where'+item}>
                                    <div>
                                        <img alt="" src="/assets/images/projects/11.jpg" />
                                    </div>
                                    <div className="propery_detail">
                                        <h4 className="property_title">Loss Vengel New Apertment</h4>
                                        <p><FiMapPin /> San Fransico</p>
                                        <p className="tag">For Sale</p>
                                        <p>3 days ago</p>
                                            
                                    </div>
                                </li>
                              ))
                          }
                        </ul>
                    </div>

              
                   <div className="featured_properties">
                        <div className="properties_head"> 
                          <h3>Featured Properties</h3>
                          <div className="property_actions">
                                <div className="action_icon">
                                    <FiChevronLeft />
                                </div>
                                <div className="action_icon">
                                    <FiChevronRight />
                                </div>
                          </div>
                        </div>

                        <div className="featured_image">
                            <img alt="" src="/assets/images/projects/13.jpg" draggable="false" />
                           <div className="featured_details">
                                 <p className="featured_title">Arlo Apartment</p>
                                <p className="category">Featured</p>
                                <p className="tag">For Rent</p>
                            </div>
                        </div>
                    </div>
                    
                
                    <div className="skills">
                        <h3>Skills</h3>
                        <ul>
                            <li>IOS</li>
                            <li>Android</li>
                            <li>Mobile App</li>
                            <li>Python</li>
                            <li>Java</li>
                            <li>Graphic Design</li>
                            <li>Flask</li>
                            <li>PHP</li>
                            <li>WordPress</li>
                        </ul>
                    </div>
                    <div className="project_show__information">
                        <div className="head">
                            <h5 className="head_title">Job Summary</h5>
                        </div>
                        <ul>
                            <li>
                                <div>
                                    <FiMapPin />
                                </div>
                                <div>
                                    <h4 className="info_title">Location</h4>
                                    <p>Cairo, Egypt</p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <FiBriefcase />
                                </div>
                                <div>
                                    <h4 className="info_title">Job Type</h4>
                                    <p>Full Time</p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <FiDollarSign />
                                </div>
                                <div>
                                    <h4 className="info_title">Salary</h4>
                                    <p>$35K - $38K</p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <FiCalendar />
                                </div>
                                <div>
                                    <h4 className="info_title">Date Posted</h4>
                                    <p>1 hours ago</p>
                                </div>
                            </li>

                        </ul>
                    </div>


                    <div className="project_show__categories">
                        <div className="head">
                            <h5 className="head_title">Job Details</h5>
                        </div>                        
                        <ul>
                            <li>
                                <div className="icon">
                                   <FiPlay />
                                </div>
                                <p>Architecture</p>
                            </li>                            
                            <li>
                                <div  className="icon">
                                   <FiPlay />
                                </div>
                                <p>IT and Computers</p>
                            </li>                            
                            <li>
                                <div  className="icon">
                                   <FiPlay />
                                </div>
                                <p>Education Trainings</p>
                            </li>                            
                            <li>
                                <div  className="icon">
                                   <FiPlay />
                                </div>
                                <p>Customer Service</p>
                            </li>

                        </ul>
                        <div className="btn">View All Category</div>
                    </div>
                  
                    <div className="project_show__tags">
                    </div>

                    
                </div>  
            </div>
        </div>
      </>
    ) 
}




export default ProjectPage;
